import React from 'react';
import { Graphic } from '../../components/graphic/Graphic';
import styles from './graphicPage.module.scss';

const GraphicPage: React.FC = () => {
	return (
		<div className={styles.graphicPageContainer} id='graphicPageContainer'>
			<Graphic />
		</div>
	);
};

export { GraphicPage };
